import { combineReducers } from "redux";
import authSlice from "./authSlice";
import loadingSlice from "./loadingSlice";
import generalApiSlice from "./generalApiSlice";
import FCMSlice from "./FCMSlice";
import SubscriptionSlice from "./SubscriptionSlice";
import notificationSlice from "./notificationSlice";
import ammenitiesRangeSlice from "./ammenitiesRangeSlice";
import screenBgSlice from "./screenBgSlice";
import beneficiarySlice from "./beneficiarySlice";
import walletPaymentSlice from "./walletPaymentSlice";
import subscriptionExpiredSlice from "./subscriptionExpired"
import onlinePaymentSlice from "./onlinePaymentSlice";
const rootReducer = combineReducers({
  authReducer: authSlice,
  loadingReducer: loadingSlice,
  generalApiReducer: generalApiSlice,
  FCMReducer: FCMSlice,
  subscriptionReducer: SubscriptionSlice,
  notificationReducer: notificationSlice,
  ammenitiesRangeReducer: ammenitiesRangeSlice,
  screenBgReducer: screenBgSlice,
  beneficiaryReducer: beneficiarySlice,
  walletPaymentReducer: walletPaymentSlice,
  subscriptionExpiredReducer: subscriptionExpiredSlice,
  onlinePaymentReducer: onlinePaymentSlice


});
export default rootReducer;
